import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../../../../useAuth";
import { getProjectAccessRoute } from "../../../../../../utils/routes";
import { ProjectContext } from "../../ProjectContext";

interface UseInviteReturnData {
  pageTitle?: string;
  handleBackClick: () => void;
}

export const useInvite = (): UseInviteReturnData => {
  const navigate = useNavigate();
  const { currentUserType } = useAuth();
  const { projectDetails } = useContext(ProjectContext);

  const handleBackClick = (): void => {
    if (projectDetails?.uuid) {
      navigate(getProjectAccessRoute(projectDetails.uuid, currentUserType));
    }
  };

  return {
    pageTitle: projectDetails?.displayName,
    handleBackClick,
  };
};
